module.exports = __webpack_public_path__ + "img/-LV58PC5jNelCMcNxQuT.54e6a849.jpg";